export default "__VITE_ASSET__579a672d__"